export default __webpack_public_path__ + "media/zurb/img/about/culture/culture-img6-3f37587febf91fc388b42eb53ec50c47.png";